import React, { useState } from "react";

import PropTypes from "prop-types";

// Functions
import isEmpty from "../../validation/is-empty";

// Components
import ToggleWrapper from "../benchmarking-toggles/BenchmarkingAnonymousToggle.components";

// Styles
import "./BenchmarkingAnonymity.css";

/// props validation | SQ(javascript:S6774)
BenchmarkingAnonymity.propTypes = {
  caller: PropTypes.string,
  user: PropTypes.object,
  linkedBenchmarksIds: PropTypes.array,
  linkedBenchmarksIdsParentId: PropTypes.string,
  linkedBenchmarks: PropTypes.array,
  updateState: PropTypes.func,
};
///
export default function BenchmarkingAnonymity(props) {
  const [isLocked, setIsLocked] = useState(false);

  const { caller } = props;
  const { user } = props;

  const { linkedBenchmarksIds } = props;
  const { linkedBenchmarksIdsParentId } = props;
  const { linkedBenchmarks } = props;
  const { updateState } = props;

  if (typeof updateState !== "function") {
    return <></>;
  }

  const display = [];

  // Add blank first row in Cost Planning
  const showThisBenchmarkToggle = ["COST_PLAN_BENCHMARKING"].includes(caller);
  if (showThisBenchmarkToggle) {
    display.push(<div key={"0-wrapper"} className="toggle-wrapper"></div>);
  }

  linkedBenchmarks.forEach((linkedBenchmark) => {
    const linkedBenchmarkId = linkedBenchmarksIds.find(
      (x) => x.benchmarkId === linkedBenchmark.id
    );

    if (!isEmpty(linkedBenchmarkId)) {
      display.push(
        <ToggleWrapper
          key={linkedBenchmarkId.benchmarkId}
          name={
            linkedBenchmark.project_name_original ||
            linkedBenchmark.project_name
          }
          isAnonymous={linkedBenchmarkId.isAnonymous}
          comparisonId={linkedBenchmarkId.benchmarkId}
          benchmarkId={linkedBenchmarksIdsParentId}
          linkedBenchmarksIds={linkedBenchmarksIds}
          user={user}
          // Toggle State
          showToggle={true}
          setIsLocked={setIsLocked}
          isLocked={isLocked}
          // Update Function
          updateState={updateState}
        />
      );
    }
  });

  return <div className="benchmarking-table-anonymity">{display}</div>;
}
